/** @format */

import React, { useState } from 'react'
import styled from 'styled-components'
import { _$, Button } from '@king-design/react'
import { ServiceOverviewSearchProps } from '../../components/typescript'
import { TableSearch, parseTableSearchParams } from 'src/components'
import { TraceAnalysisSearchProps, FilterMtchProps } from '../typescript'
import { initSpanAttributeFilters, initTraceAnalysisSearch } from '../constant'
import SpanSearch from './SpanSearch'
import TraceSearch from './TraceSearch'
import TraceTable from './TraceTable'
import { useLocation } from 'react-router-dom'
import variable from 'src/static/styles/var'

interface TraceContainerProps {
  className?: string
  headerSearch: ServiceOverviewSearchProps
  serviceName?: string
  region?: string
}

const TraceContainer: React.FC<TraceContainerProps> = ({
  className,
  headerSearch,
  serviceName,
  region
}) => {
  const location = useLocation()
  const urlParams = parseTableSearchParams(location.search, 'traceSearch') || {}
  const [traceSearch, setTraceSearch] = useState<TraceAnalysisSearchProps>(() => {
    return {
      ...initTraceAnalysisSearch,
      // 从服务详情跳入时预填服务名
      Filters: serviceName
        ? [
            {
              Key: 'service_name',
              Op: 'in',
              Values: [serviceName]
            }
          ]
        : initTraceAnalysisSearch.Filters,
      ...urlParams
    }
  })
  const [spanSearch, setSpanSearch] = useState<FilterMtchProps[]>(() => {
    return Array.isArray(urlParams?.spanSearch)
      ? (urlParams?.spanSearch as FilterMtchProps[])
      : initSpanAttributeFilters
  })

  return (
    <div className={className}>
      <TableSearch
        params={{
          ...traceSearch,
          spanSearch: spanSearch
        }}
        noStyle
        paramsKey="traceSearch"
      >
        <div
          className="trace-analysis-sidebar"
          aria-label={_$('列表筛选')}
          style={{
            maxHeight: `calc(100vh - ${variable.pagePadding} - ${serviceName ? '97px' : '48px'})`
          }}
        >
          <div className="session-search-title">
            <span>{_$('快捷筛选')}</span>
            <Button
              type="link"
              onClick={() => {
                setTraceSearch({
                  ...initTraceAnalysisSearch,
                  Filters: serviceName
                    ? [
                        {
                          Key: 'service_name',
                          Op: 'in',
                          Values: [serviceName]
                        }
                      ]
                    : initTraceAnalysisSearch.Filters
                })
                setSpanSearch(initSpanAttributeFilters)
              }}
            >
              {_$('重置')}
            </Button>
          </div>
          <TraceSearch
            startTime={headerSearch?.time[0]}
            endTime={headerSearch?.time[1]}
            value={traceSearch.Filters}
            serviceName={serviceName}
            onChange={filters => {
              setTraceSearch({ ...traceSearch, Page: 1, Filters: filters })
            }}
          />
          <SpanSearch
            startTime={headerSearch?.time[0]}
            endTime={headerSearch?.time[1]}
            value={spanSearch}
            onChange={setSpanSearch}
          />
        </div>
      </TableSearch>
      <TraceTable
        headerSearch={headerSearch}
        serviceName={serviceName}
        traceSearch={traceSearch}
        setTraceSearch={setTraceSearch}
        spanSearch={spanSearch}
        region={region}
      />
    </div>
  )
}

export default styled(TraceContainer)`
  display: flex;
  .trace-analysis-sidebar {
    width: 200px;
    padding-right: 12px;
    overflow-y: auto;
    .session-search-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 14px;
        font-weight: 500;
      }
      button {
        padding: 0;
      }
    }
  }
`
